document.querySelectorAll('[data-pr-duo-form]').forEach((form) => {
  if (form.dataset.bound) return;
  form.dataset.bound = 'true';
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (form.dataset.pending) return;
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-pr-duo-error]');
    const quantity = Number(form.elements.namedItem('quantity')?.value || 1);
    const items = [0, 1].map((index) => ({
      id: Number(form.elements.namedItem(`items[${index}][id]`).value),
      quantity,
    }));
    if (!Number.isInteger(quantity) || quantity < 1 || items.some((item) => !item.id)) return;
    form.dataset.pending = 'true';
    button.disabled = true;
    error.hidden = true;
    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || form.dataset.error);
      window.location.assign(form.dataset.cartUrl);
    } catch (failure) {
      error.textContent = failure.message || form.dataset.error;
      error.hidden = false;
      button.disabled = false;
      delete form.dataset.pending;
    }
  });
});
